
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/disk",
      function () {
        return require("private-next-pages/profile/disk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/disk"])
      });
    }
  